import type { FieldErrors, UseFormRegister } from "react-hook-form";
import { useFondByIdQuery } from "../../stores/OkOkStore";
import type { DemandeInsert } from "../../types/Demande";
import { FloatingPostfixInputBootStrap } from "../Common/FloatingInputBootstrap";
import { useTrads } from "../../contexts/trads/useTrads";

function DemandeFrais({fondId,register,errors}:{fondId:number,register:UseFormRegister<DemandeInsert>,errors:FieldErrors<DemandeInsert>}){
    const { data, error, isLoading } = useFondByIdQuery(fondId.toString());
    const {translate}=useTrads();

    return (
            error ? (
               <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

            ) : isLoading ? (
                <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
            ) : data ? (
                <>
                {data.type_frais?.map(e=> ( 
                    
                    <div className="col-4  mb-3" key={e.name}>
                        <FloatingPostfixInputBootStrap
                            name={`frais.${e.type_frais_id.toString()}`}
                            label={e.name??'Frais??'}
                            prefix="€"
                            type="number"
                            rest={{"step":"0.01"}}
                            errors={errors}
                            registerOutput={register(`frais.${e.type_frais_id.toString()}`,{valueAsNumber: true})}
                        />
                    </div>
                    
                    
                    ) )}
                </>
        ):null
    );
}
export default DemandeFrais;